import SEOHead from '../../components/feature/SEOHead';
import { SITE_URL } from '../../utils/seo';
import AnnouncementBar from '../home/components/AnnouncementBar';
import Navbar from '../home/components/Navbar';
import FooterSection from '../home/components/FooterSection';
import ArchHero from './components/ArchHero';
import PowerOfOne from './components/PowerOfOne';
import Capabilities from './components/Capabilities';
import LightBoard from './components/LightBoard';
import ArchSections from './components/ArchSections';
import MultiTenancy from './components/MultiTenancy';

const archJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'VergeOS',
  applicationCategory: 'BusinessApplication',
  operatingSystem: 'Any',
  description: 'VergeOS birleşik mimarisi: sanallaştırma, depolama ve ağı tek bir platformda yönetin. HCI karmaşıklığını aşın.',
  url: `${SITE_URL}/architecture`,
};

export default function ArchitecturePage() {
  return (
    <div className="min-h-screen w-full">
      <SEOHead
        title="VergeOS Mimarisi | Tek Platform Tüm Altyapı"
        description="VergeOS'un birleşik mimarisini keşfedin. Sanallaştırma, depolama ve ağı tek bir platformda yönetin. HCI karmaşıklığını ortadan kaldırın, maliyetleri azaltın."
        keywords="VergeOS mimari, ultraconverged altyapı, sanallaştırma platformu, özel bulut mimarisi, HCI"
        canonicalPath="/architecture"
        jsonLd={archJsonLd}
      />
      <AnnouncementBar />
      <Navbar />
      <main>
        <ArchHero />
        <PowerOfOne />
        <Capabilities />
        <LightBoard />
        <ArchSections />
        <MultiTenancy />
      </main>
      <FooterSection />
    </div>
  );
}